import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { PoTagModule, PoWidgetModule } from '@po-ui/ng-components';

interface OrderItem {
  packItemNumber: number;
  productSku: string;
  productCode: number;
  productName: string;
  productColor: string;
  quantity: number;
  status: number;
  productSkus: productSkus[];
  expanded?: boolean;
};

interface productSkus {
  productSku: string;
}

@Component({
  selector: 'app-card',
  imports: [PoWidgetModule, CommonModule, PoTagModule],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent implements OnInit {
  @Input() myData: OrderItem[] | undefined;
  @Input() switchRemove: boolean = false;
  @Input() myDataItens: productSkus[] | undefined;
   
  getStatusColor(status: number) {
    switch (status) {
      case 1:
        return 'color-11';
      default:
        return 'color-02';
    }
  }

  constructor() { }

  ngOnInit() {
  }

  seeDescriptionItens(item: OrderItem) {
    item.expanded = !item.expanded;
  }
}
